import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  surveyData: null,
};

const mySurveysSlice = createSlice({
  name: "mySurveys",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setSurveyData: (state, action) => {
      state.surveyData = action.payload;
    },
    resetMySurveysState: (state) => {
      state.loading = false;
      state.error = null;
      state.surveyData = null;
    },
  },
});

export const { setLoading, setError, setSurveyData, resetMySurveysState } =
  mySurveysSlice.actions;

export default mySurveysSlice.reducer;
